import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const OkIcon = (props: IconProps) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 72 72"
      {...props}
    >
      <path fill="#FFCC4D" d="M36 72a36 36 0 1 0 0-72 36 36 0 0 0 0 72Z" />
      <path
        fill="#664500"
        d="M21 47.2c.1.4 2.4 8.8 15 8.8s14.9-8.4 15-8.8a1 1 0 0 0-1.7-1c0 .1-4 3.8-13.3 3.8-9.4 0-13.3-3.7-13.3-3.7a1 1 0 0 0-1.6.3v.6ZM24 34c2.8 0 5-3.1 5-7s-2.2-7-5-7-5 3.1-5 7 2.2 7 5 7ZM48 34c2.8 0 5-3.1 5-7s-2.2-7-5-7-5 3.1-5 7 2.2 7 5 7Z"
      />
    </Icon>
  );
};

export default OkIcon;
